import { render, staticRenderFns } from "./chartererAdditionalFreight.vue?vue&type=template&id=c4b03f24"
import script from "./chartererAdditionalFreight.vue?vue&type=script&lang=js"
export * from "./chartererAdditionalFreight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports